

import { Container } from 'inversify';
import { defineComponent, ref, onMounted } from 'vue';
import { useI18n } from 'vue-i18n';
import { messages } from './localization/MessagesBusqueda';
import { helpers, required, requiredIf } from '@vuelidate/validators';
import useVuelidate from '@vuelidate/core';
import { IapCatalog } from '../../../catalog/domain/iapCatalog';
import { clave, claveNew } from '../../../dataupdate/domain/clave';
import DataSourceComp from '../functions/dataSourceComp';
import HelperCommon from '../../../../../common/infrastructure/funciones/HelperCommon';
import OperationDataTypeConst from '../../../../../common/domain/constantes/OperationDataTypeConst';
import { IServiceDataUpdate } from '../../../dataupdate/application/IServiceDataUpdate';
import { TYPES } from '../../../../../common/domain/types';
import HelperLoading from '../../../../../common/infrastructure/funciones/HelperLoading';
import { MessageService } from '../../../../../common/infrastructure/servicios';
import { MessageType } from '../../../../../common/infrastructure/servicios/MessageService';
import SqlTypesConst from '../../../../../common/domain/constantes/SqlTypesConst';
import { dataUpdate } from '../../../dataupdate/domain/dataUpdate';
import { IapDataSourceField } from '../../../datasource/domain/iapDataSourceField';
import { IapComponentDataSource } from '../../../component/domain/iapComponentDataSource';
import DataSourceConst from '../functions/dataSourceConst';
import { IapComponent } from '../../../component/domain/iapComponent';
import HelperUtils from '../../../../../common/infrastructure/funciones/HelperUtils';
import { useStore } from 'vuex';

export default defineComponent({
    name: 'masive_update',
    props: {
        container: {
            type: Object as () => Container
        },
        Component: {
            type: Object as () => IapComponent,
            default: () => ({})
        },

        catalogosData: {
            type: Object as () => IapCatalog[],
            default: () => ([])
        },

        compDataSource: {
            type: Object as () => IapComponentDataSource,
            default: () => ({})
        },
        selectedItems: {
            type: Object,
            default: () => ([])
        },
    },
    emits: ['refreshData'],
    setup(props, { emit }) {
        const store = useStore();
        const { t, locale } = useI18n(messages)
        const { isType, isCatalogType, isTableType, dataBaseId, tablasData, getDefaultvalue } = DataSourceComp(props.container as any, props, emit, t, props.compDataSource, props.catalogosData,store)
        const submitted = ref(false);
        const dataInput = ref<claveNew[]>([]);
        const checked = ref<Array<String>>([]);
        const reglas = {
            items: {
                $each: helpers.forEach({
                    value: {
                        required: helpers.withMessage('El campo es obligatorio', requiredIf((...args) => {
                            var datos = args as any;
                            return !checkDisabledControl(datos[args.length - 1].field) && datos[args.length - 1].required
                                && !(datos[args.length - 1].value)

                        }
                        )),
                    },
                })
            }
        }

        //requiredIf(prop => prop.type === 'input')


        const v$ = useVuelidate(reglas, { items: dataInput });



        const isColumnType = (columna: string, tipo: string) => {

            var item = tablasData.value.find(x => (dataBaseId.value + DataSourceConst.DELIMITERFIELDS + x.tableName + DataSourceConst.DELIMITERFIELDS + x.field) == columna)
            if (item) {
                return isType(item, tipo);
            }

            return false;
        }


        const isCatalogTypeValue = (columna: string) => {
            var item = tablasData.value.find(x => (dataBaseId.value + DataSourceConst.DELIMITERFIELDS + x.tableName + DataSourceConst.DELIMITERFIELDS + x.field) == columna)
            if (item) {
                const resu = isCatalogType(item)
                return resu
            }
            else {
                return false;
            }
        }


        const isTableTypeValue = (columna: string) => {
            var item = tablasData.value.find(x => (dataBaseId.value + DataSourceConst.DELIMITERFIELDS + x.tableName + DataSourceConst.DELIMITERFIELDS + x.field) == columna)
            if (item) {
                const resu = isTableType(item)
                return resu
            }
            else {
                return false;
            }
        }




        const getCatalogData = (columna: string) => {
            var item = tablasData.value.find(x => (dataBaseId.value + DataSourceConst.DELIMITERFIELDS + x.tableName + DataSourceConst.DELIMITERFIELDS + x.field) == columna)
            if (item) {
                const tipoCatalogoid = item.catalogTypeId
                return props.catalogosData.filter(x => x.typeId == tipoCatalogoid).sort((a, b) => { return a.order - b.order; })
            }
            return []
        }

        const getColumnName = (columna: string) => {
            var item = tablasData.value.find(x => (dataBaseId.value + DataSourceConst.DELIMITERFIELDS + x.tableName + DataSourceConst.DELIMITERFIELDS + x.field) == columna)
            return item?.field ?? columna
        }


        const isValidData = (): boolean => {
            submitted.value = true;
            v$.value.$reset();
            v$.value.$touch();
            if (v$.value.$invalid) {
                HelperCommon.setFocusOnFirstError();
                return false;
            }

            return true;
        }

        const getPrimaryKeys = (data: any, columna: string): clave[] => {
            const _outputData: clave[] = [];
            //var _data = columna.split(DELIMITERFIELDS);
            const tableName = tablasData.value.find(x => columna == (dataBaseId.value + DataSourceConst.DELIMITERFIELDS + x.tableName + DataSourceConst.DELIMITERFIELDS + x.field))?.tableName

            const keys = tablasData.value.filter(x => x.tableName == tableName && x.primaryKey).map(x =>
                dataBaseId.value + DataSourceConst.DELIMITERFIELDS + x.tableName + DataSourceConst.DELIMITERFIELDS + x.field
            );
            keys.forEach(k => {
                _outputData.push({
                    dataBase: dataBaseId.value ?? '',
                    table: tableName ?? '',
                    field: k,
                    value: data[k]
                })
            })

            return _outputData;
        }

        const saveData = () => {
            if (isValidData() && props.container) {
                const dataToUpdate = props.selectedItems.map((item: any) =>
                ({
                    valores: dataInput.value.filter(c => checked.value.includes(c.field)).map(x => ({
                        dataBase: x.dataBase,
                        table: x.table,
                        field: x.field,
                        value: isColumnType(x.field, SqlTypesConst.BIT) ? JSON.stringify(x.value) : x.value
                    })) as any,
                    claves: getPrimaryKeys(item, Object.keys(item)[0]),
                    tipoOperacion: OperationDataTypeConst.UPDATE,
                    id:HelperUtils.newGuid()
                } as dataUpdate)) as dataUpdate[]

                const _srv = props.container.get<IServiceDataUpdate>(TYPES.DATAUPDATE_REPOSITORY)
                HelperLoading.showLoading()
                const requestData = JSON.parse(JSON.stringify(dataToUpdate))
                _srv.update(props.Component.applicationId, props.Component.applicationVersion, props.Component.id, props.compDataSource.id, requestData,true).then(response => {
                    if (response) {
                        MessageService.showToast(MessageType.Correcto, "", 'Registros modificados correctamente.')
                        emit('refreshData')
                    }
                }).finally(() => {
                    HelperLoading.hideLoading()
                })


            }
        }



        const checkDisabledControl = (key: any) => {
            return !checked.value?.includes(key)
        }

        onMounted(() => {
            dataInput.value = tablasData.value.filter(x => !((x.identityColumn) || (x.primaryKey))
                && props.compDataSource.iapComponentDataSourceFieldConfigurations.find(c => c.dataSourceFieldId == x.id)?.editMassive
            )
                .sort((a, b) => { return (a.position ?? 0) - (b.position ?? 0); })
                .map(x => ({
                    dataBase: dataBaseId.value,
                    table: x.tableName,
                    field: dataBaseId.value + DataSourceConst.DELIMITERFIELDS + x.tableName + DataSourceConst.DELIMITERFIELDS + x.field,
                    value: getDefaultvalue(x,props.compDataSource.iapComponentDataSourceFieldConfigurations.find(c => c.dataSourceFieldId == x.id)?.defaultValue),
                    required: !x.nullable || props.compDataSource.iapComponentDataSourceFieldConfigurations.find(c => c.dataSourceFieldId == x.id)?.mandatory
                })) as any

        })

        return {
            t,
            v$,
            submitted,
            SqlTypesConst,
            dataInput,
            isColumnType,
            isCatalogTypeValue,
            isTableTypeValue,
            getCatalogData,
            getColumnName,
            saveData,
            checked,
            checkDisabledControl
        };
    },
});
